import { useEffect } from 'react'

import { useMemoizedFn } from 'ahooks'
import { COMMAND_PRIORITY_CRITICAL, SELECTION_CHANGE_COMMAND } from 'lexical'

import { useEditor } from '../useEditor'

export const useSelectionChange = (callback: () => boolean | void) => {
  const editor = useEditor()
  const listener = useMemoizedFn(callback)

  useEffect(() => {
    return editor.registerCommand(
      SELECTION_CHANGE_COMMAND,
      () => {
        return listener() ?? false
      },
      COMMAND_PRIORITY_CRITICAL
    )
  }, [editor, listener])
}
